import React from 'react';

import AddRecipientsForm from 'src/presentation/components/pages/proactiveCommunications/components/shared/AddRecipientsForm';

const AddSmsRecipientsForm = ({ campaign, item, root, 'data-aid': dataAid }) => {
  const startDateTimeDescription = (
    <>
      Set the date and time when Gladly starts sending SMSes to your recipients. Messages will only be sent within the
      Campaign
      <br /> schedule hours.
    </>
  );

  return (
    <AddRecipientsForm
      campaign={campaign}
      data-aid={dataAid}
      item={item}
      root={root}
      startDateTimeDescription={startDateTimeDescription}
    />
  );
};

export default AddSmsRecipientsForm;
